import Vue from 'vue';

function inicialMaiuscula(string) {
    if (string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return '';
}

function mesExtenso(mes) {
    let meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro',  'Novembro',  'Dezembro'];
    return meses[mes - 1];
}

function dataBR(data) {
    if (data) {
      return (new Date(data)).toLocaleDateString('pt-br', { timeZone: 'UTC' });
    }
  
    return '';
}

function dataHoraBR(data) {
    if (data) {
      return (new Date(data)).toLocaleString('pt-br', { timeZone: 'America/Recife' });
    }
  
    return '';
}

function valorBR(valor, decimais = 2) {
    if (valor) {
      return (parseFloat(valor)).toLocaleString('pt-br', { minimumFractionDigits: decimais, maximumFractionDigits: decimais });
    }
  
    return (0).toLocaleString('pt-br', { minimumFractionDigits: decimais, maximumFractionDigits: decimais } );
}

function capitalized(texto) {
    return texto.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
}

Vue.filter("inicialMaiuscula", inicialMaiuscula);
Vue.filter("mesExtenso", mesExtenso);
Vue.filter("dataBR", dataBR);
Vue.filter("dataHoraBR", dataHoraBR);
Vue.filter("valorBR", valorBR);
Vue.filter("capitalized", capitalized);